import React from 'react'

import { cn } from '../ui/cn'

interface CardProps {
  children: React.ReactNode
  className?: string
  as?: React.ElementType
}

/**
 * Simple rounded card surface. Wraps `.snplay-card` (defined in globals.css)
 * so consumers can theme via className without knowing the base utility.
 * Matches playground Card exactly.
 */
export const Card = ({
  children,
  className,
  as: Component = 'div',
}: CardProps): React.ReactElement => {
  return <Component className={cn('snplay-card', className)}>{children}</Component>
}
